"use client";

import { usePageAnimations } from "@/hooks/usePageAnimations";

/**
 * Client leaf that runs the selector-based GSAP page animations
 * (usePageAnimations). Rendering this anywhere on a server-component page is
 * equivalent to the page body calling the hook itself, since the hook only
 * queries the DOM (".industry-section" etc.) and renders nothing.
 */
export default function PageAnimations() {
  usePageAnimations();
  return null;
}
